const type = {
  base: 'Roboto, Helvetica Neue, Helvetica, Arial, san-serif',
  bold: 'Roboto, Helvetica Neue, Helvetica, Arial, san-serif',
  emphasis: 'Roboto, Helvetica Neue, Helvetica, Arial, san-serif',
  monospace: 'Roboto Mono, Menlo, monospace'
};

const size = {
  h1: 38,
  h2: 34,
  h3: 30,
  h4: 26,
  h5: 20,
  h6: 19,
  input: 18,
  regular: 17,
  medium: 14,
  small: 12,
  tiny: 8.5
};

const style = {
  h1: {
    fontFamily: type.base,
    fontSize: size.h1,
    fontWeight: 100
  },
  h2: {
    fontFamily: type.base,
    fontWeight: 700,
    fontSize: size.h2
  },
  h3: {
    fontFamily: type.emphasis,
    fontSize: size.h3,
    fontWeight: 400
  },
  h4: {
    fontFamily: type.base,
    fontSize: size.h4,
    fontWeight: 400
  },
  h5: {
    fontFamily: type.base,
    fontSize: size.h5,
    fontWeight: 400
  },
  h6: {
    fontFamily: type.emphasis,
    fontSize: size.h6,
    fontWeight: 400
  },
  normal: {
    fontFamily: type.base,
    fontSize: size.regular,
    fontWeight: 400
  },
  description: {
    fontFamily: type.base,
    fontSize: size.regular,
    fontWeight: 400
  },
  input: {
    fontFamily: type.base,
    fontSize: size.medium,
    fontWeight: 400
  },
  passwordInput: {
    fontFamily: type.monospace,
    fontSize: size.h4,
    fontWeight: 400
  },
  placeholder: {
    fontFamily: type.base,
    fontSize: size.medium,
    fontWeight: 400
  },
  button: {
    fontFamily: type.base,
    fontSize: size.medium,
    fontWeight: 500,
    textTransform: 'uppercase'
  }
};

export default {
  type,
  size,
  style
};
